<form [formGroup]="form" (ngSubmit)="onSubmit()" class="formgrid grid">
  <div class="field col-12">
    <div class="h-full flex flex-column">
      <div
        class="profile-foto-big border-2 border-black-alpha-20 p-1 mb-2"
        (click)="fotoInput.click()"
        pTooltip="Clique na imagem para selecionar uma foto"
        [ngClass]="{ 'foto-disabled': disable }"
        >
        @if (foto) {
          <img alt="foto de perfil" [src]="foto" />
        }
        @if (!foto) {
          <img alt="foto de perfil" src="assets/images/user-avatar.jpg" />
        }
      </div>
      <input #fotoInput type="file" name="foto" class="hidden" accept="image/*" (change)="fotoChanged($event)" />
    </div>
  </div>

  <div class="field col-12 md:col-6">
    <label for="nm_usuario" class="block font-medium">Nome *</label>
    <input id="nm_usuario" type="text" formControlName="nm_usuario" pInputText class="w-full" />
  </div>

  <div class="field col-12 md:col-6">
    <label for="ds_email" class="block font-medium">E-mail *</label>
    <input id="ds_email" type="text" formControlName="ds_email" pInputText class="w-full" />
  </div>

  <div class="field col-12 md:col-6">
    <label for="nr_cpf" class="block font-medium">CPF</label>
    <p-inputMask
      name="nr_cpf"
      styleClass="w-full"
      mask="999.999.999-99"
      formControlName="nr_cpf"
      [unmask]="true"
    ></p-inputMask>
  </div>

  <div class="field col-12 md:col-6">
    <label for="ds_cargo" class="block font-medium">Cargo</label>
    <input id="ds_cargo" type="text" formControlName="ds_cargo" pInputText class="w-full" />
  </div>

  <div class="field col-12 md:col-6">
    <label for="nr_fone_comercial" class="block font-medium">Telefone comercial</label>
    <p-inputMask
      name="nr_fone_comercial"
      styleClass="w-full"
      mask="(99) 9999-9999"
      formControlName="nr_fone_comercial"
    ></p-inputMask>
  </div>

  <div class="field col-12 md:col-6">
    <label for="nr_fone_celular" class="block font-medium">Telefone celular</label>
    <p-inputMask
      name="nr_fone_celular"
      styleClass="w-full"
      mask="(99) 99999-9999"
      formControlName="nr_fone_celular"
    ></p-inputMask>
  </div>

  @if (exibeOperadoraPreferencial) {
    <div class="field col-12 md:col-6">
      <label class="block font-medium">Operadora preferencial</label>
      <bl-operadoras-select
        [operadoras]="operadoras"
        [selectedOperadora]="operadoraPreferencial"
        (operadoraChanged)="onChangeOperadora($event)"
        [disable]="disable"
        [showClear]="showClear"
      ></bl-operadoras-select>
    </div>
  }

  @if (!hideSensitiveInputs) {
    <div class="field col-12 md:col-6">
      <label for="cd_papel_acesso" class="block font-medium">Papel de acesso no Gestor IDSS</label>
      <p-select
        id="cd_papel_acesso"
        formControlName="cd_papel_acesso"
        [options]="papeisAcesso"
        optionLabel="ds_papel_acesso"
        optionValue="cd_papel_acesso"
        placeholder="Selecione um papel"
        appendTo="body"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div class="field col-12 md:col-6">
      <label class="block font-medium">Situação</label>
      <p-toggleswitch formControlName="ib_situacao"></p-toggleswitch>
      <label class="ml-2">{{ situacao ? 'Ativo' : 'Inativo' }}</label>
    </div>
  }

  @if (!disable) {
    <div class="col-12 flex justify-content-end mb-4">
      <button type="submit" pButton class="mr-2" [disabled]="form.invalid || form.pristine">Salvar</button>
      <button type="button" pButton class="p-button-outlined" (click)="onCancelEdit()">Cancelar</button>
    </div>
  }
</form>
